module.exports = __webpack_public_path__ + "static/img/mz.ada07465.svg";